export const SortBy = {
  New: 'new',
  Distance: 'distance',
  Recent: 'recent',
};

export const Locations = {
  Current: 'current',
};
